export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Старий пароль"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новий пароль"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердження паролю"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зберегти"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Новий пароль\" і \"Підтвердження паролю\" не збігаються."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зміна паролю"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рядок від 4 до 63 символів. Допустимі символи латинського алфавіту, цифри та символи"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Порожньо"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Слабкий"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Середній"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сильний"])}
  }
}